import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const StoredObjectButtons = ({ row: object, repositoryService }) => {
  return (
    <div className="grb-storedobject-actions">
      <Tooltip title="Download">
        <a href={repositoryService.getStoreObjectDownloadURL(object.id)} download>
          <IconButton size="small">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" /></svg>
          </IconButton>
        </a>
      </Tooltip>
    </div>
  );
};

StoredObjectButtons.propTypes = {
  repositoryService: PropTypes.shape({
    getStoreObjectDownloadURL: PropTypes.func.isRequired,
  }).isRequired,
  row: PropTypes.shape({}).isRequired,
};

StoredObjectButtons.defaultProps = {
};

export default StoredObjectButtons;
